/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HiringSite, State } from 'eve-account-client';
import { object, string } from 'yup';

export type ValidationResult = {
  validSites: HiringSite[];
  invalidSites: HiringSite[];
  errorMessage?: string;
};

export class HiringSiteValidator {
  states: State[];

  existingSites: HiringSite[];

  constructor(states: State[], existingSites: HiringSite[]) {
    this.states = states;
    this.existingSites = existingSites;
  }

  hiringSiteSchema = object({
    line1: string()
      .trim()
      .required()
      .max(50)
      .matches(/^[a-zA-Z0-9\-‒–—―. ]*$/),
    line2: string()
      .trim()
      .max(50)
      .matches(/^[a-zA-Z0-9\-‒–—―. ]*$/),
    city: string()
      .trim()
      .required()
      .max(30)
      .matches(/^[a-zA-Z0-9\-‒–—― ]*$/),
    stateCode: string()
      .trim()
      .required()
      .test((value) => this.states.filter((state) => state.code === value).length === 1),
    zipCode: string()
      .required()
      .matches(/^[0-9]+$/)
      .min(5)
      .max(5),
  });

  private static trimAndFilterOutBlankRows(hiringSites: HiringSite[]): HiringSite[] {
    return hiringSites.filter((site) => {
      site.line1 = site.line1.trim();
      site.line2 = site.line2?.trim();
      site.city = site.city.trim();
      site.stateCode = site.stateCode.trim();
      site.zipCode = site.zipCode.trim();
      return !(site.line1.length === 0 && site.line2
        ? site.line2?.length === 0
        : true && site.city.length === 0 && site.zipCode.length === 0 && site.stateCode.length === 0);
    });
  }

  validate(hiringSites: HiringSite[]): ValidationResult {
    const validSites: HiringSite[] = [];
    const invalidSites: HiringSite[] = [];
    const filteredHiringSites = HiringSiteValidator.trimAndFilterOutBlankRows(hiringSites);

    // Basic Check + Duplication Check
    filteredHiringSites.forEach((site) => {
      const matchingSitesFound = [...this.existingSites, ...filteredHiringSites].filter(
        (hiringSite) =>
          hiringSite.city === site.city &&
          hiringSite.line1 === site.line1 &&
          (hiringSite.line2 || '') === (site.line2 || '') &&
          hiringSite.stateCode === site.stateCode &&
          hiringSite.zipCode === site.zipCode,
      );
      if (matchingSitesFound.length === 1 && this.hiringSiteSchema.isValidSync(site)) {
        validSites.push(site);
      } else {
        invalidSites.push(site);
      }
    });

    return {
      validSites,
      invalidSites,
    };
  }
}
